export function createQueryKeySet<TListParams = never>(entity: string) {
  const keys = {
    all: [entity] as const,
    lists: () => [...keys.all, 'list'] as const,
    list: (params?: TListParams) => [...keys.lists(), params] as const,
    details: () => [...keys.all, 'detail'] as const,
    detail: (id: number) => [...keys.details(), id] as const,
  };

  return keys;
}
